import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { RouteInfoService } from "../../route-info.service";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { Entity } from "src/app/shared/models/entity";
import { FileService } from "../file/file.service";
import { UserCache } from "../../user-cache";
import { DateHelper } from "src/app/shared/helpers/date-helper";


export enum HelpPadTab{
    None = -1,
    CC = 0,
    PE,
    DX,
    RX,
    Set,
    HomeCare,
    Freq,
    Days,
    Dose,
    Way,
    SpRule,
    SP, //自費特殊
    ChiRx,
    ChiAsk,
    ChiLook,
    ChiPulse,
    ChiPulseLeft,
    ChiPulseRight,
    ChiBianZheng,
    ChiTreatRule,
    ChiTreatEffect,
    ChiDoctorOrder,
    CMD,
    Remark,
    SpecialRemark,
    SpecialNote
}
export enum HelpPadType{
    Self = 0,
    Clinic = 1,
    None = 2
}
export interface HelpPadGroups extends Entity {
    //Id:number
    ClinicId :number;
    UserId?:number;
    Tab: HelpPadTab;
    Type: HelpPadType;
    GroupName:string;
    PrevId:number;
    HelpPadItems:HelpPadItems[];
    IsStatic:boolean;
  }
  
  export interface HelpPadItems extends Entity {
    //Id:number;
    GroupId:number;
    ItemCode:string;
    /** 項目的資料類型 */
    ItemType:HelpPadTab;
    SN:number;
  }
export interface HelpPadGroupDto{
    Tab: HelpPadTab;
    GroupName: string;
    HelpPadItems:HelpPadItemDto[]
}
export interface HelpPadItemDto{
    ItemCode:string;
    StdCode:string;
}

@Injectable({
    providedIn: 'root'
})
  
export class HelpPadApi {
    private api: WebApiService;
    constructor(private webApiFactory: WebApiClient,private file:FileService) {
        this.api = this.webApiFactory.createHisService('Hist/helppad');
        this.api.enableLoader = false;
    }
    
    public async GetHelperPadGroups():Promise<HelpPadGroups[]>{
        return this.api.get('Get').toPromise<HelpPadGroups[]>()
    }
    public async AddGroup(group:HelpPadGroups):Promise<number>{
        return this.api.post('AddGroup',group).toPromise<number>()
    }
    public async DeleteGroup(group:HelpPadGroups){
        return this.api.delete('DeleteGroup?groupId='+group.Id).toPromise()
    }
    public async UpdateGroup(group:HelpPadGroups){
        return this.api.post('UpdateGroup',group).toPromise()
    }
    public async Export(type:HelpPadType,tabs:HelpPadTab[]){
        var resp = await this.api.getFile('Export',{type:type,tabs:tabs.join(',')}).toPromise()
        var user = UserCache.getLoginUser();
        var userName = type == HelpPadType.Self?(user.Name+'_'):'';
        var clinic = user.Clinic;
        var dt = DateHelper.formatFullDateTime(new Date());
        var fileName = `${clinic.Name}_${userName}選盤_${dt}.json`
        this.file.downloadAs(resp,fileName);
    }
    public async ImportHelperPadGroups(type:HelpPadType,tabs:HelpPadTab[],createIfEmpty:boolean){
        return this.api.post('Import?type='+type+'&createIfEmpty='+createIfEmpty,tabs).toPromise()
    }
}